<template>
  <v-expansion-panel class="custom_card">
    <v-expansion-panel-header>
      <div class="d-flex" style="gap: 10px;">
        <v-icon :color="plan.color ? plan.color.hex : null" small>
          fiber_manual_record
        </v-icon>
        {{ `${plan.display_name} (${plan.currency.code})` }}
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row no-gutters>
          <!------------------------------------------>
          <!-- NAME ----------------------------->
          <!------------------------------------------>
          <v-col cols="12" md="6">
            <!-- <span
              class="subtitle-2 grey--text text--darken-2 font-weight-regular"
              >{{ $t("pricing_model.edit.plan.name") }}</span
            > -->
            <v-text-field
              v-model="localPlan.display_name"
              :label="$t('pricing_model.edit.plan.name')"
              class="rounded-lg mt-1"
              outlined
              dense
              :rules="rules.name"
              required
            >
            </v-text-field>
          </v-col>
          <!------------------------------------------>
          <!-- FREQUENCY ----------------------------->
          <!------------------------------------------>
          <v-col cols="12" md="3" class="px-4">
            <!-- <span
              class="subtitle-2 grey--text text--darken-2 font-weight-regular"
              >{{ $t("pricing_model.edit.plan.frequency") }}</span
            > -->
            <v-select
              v-model="localPlan.frequency"
              :items="frequencies"
              disabled
              :label="$t('pricing_model.edit.plan.frequency')"
              class="rounded-lg mt-1"
              hide-details
              outlined
              dense
              required
            ></v-select>
          </v-col>
          <!------------------------------------------>
          <!-- ID ----------------------------->
          <!------------------------------------------>
          <v-col cols="12" md="3" class="px-4">
            <!-- <span
              class="subtitle-2 grey--text text--darken-2 font-weight-regular"
              >{{ $t("pricing_model.edit.plan.id") }}</span
            > -->
            <v-text-field
              v-model="localPlan.id"
              disabled
              label="ID"
              class="rounded-lg mt-1"
              hide-details
              outlined
              dense
              required
            ></v-text-field>
          </v-col>
          <!------------------------------------------>
          <!-- DESCRIPTION ----------------------------->
          <!------------------------------------------>
          <v-col cols="12">
            <!-- <span
              class="subtitle-2 grey--text text--darken-2 font-weight-regular"
              >{{ $t("pricing_model.edit.plan.description") }}</span
            > -->
            <v-text-field
              v-model="localPlan.description"
              :label="$t('pricing_model.edit.plan.description')"
              class="rounded-lg mt-1"
              outlined
              dense
              :rules="rules.description"
              required
            >
            </v-text-field>
          </v-col>
          <!------------------------------------------>
          <!-- LIMITS TABLE ----------------------------->
          <!------------------------------------------>
          <v-col cols="12" v-if="localPlan.has_limits_table" class="mb-4">
            <v-row no-gutters>
              <v-col cols="12">
                <span class="subtitle-2 grey--text text--darken-2">
                  {{
                    $t('pricing_model.view.plan.limits_table.registers.title')
                  }}
                </span>
                <!------------------------------------------>
                <!-- LIMITS REGISTERS ----------------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <span
                    class="subtitle-2 grey--text text--darken-2 font-weight-regular"
                  >
                    {{
                      $t('pricing_model.view.plan.limits_table.registers.title')
                    }}
                  </span>
                  <v-row>
                    <v-col cols="12" md="6" class="mt-4 d-flex">
                      <span
                        class="subtitle-2 mr-4 mt-3 grey--text text--darken-2 font-weight-regular"
                      >
                        {{
                          $t(
                            'pricing_model.view.plan.limits_table.registers.from'
                          )
                        }}
                      </span>
                      <v-text-field
                        :value="localPlan.offset_registers"
                        disabled
                        class="rounded-lg"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      class="mt-4 d-flex"
                      v-if="!localPlan.has_no_limits"
                    >
                      <span
                        class="subtitle-2 mr-4 mt-3 grey--text text--darken-2 font-weight-regular"
                      >
                        {{
                          $t(
                            'pricing_model.view.plan.limits_table.registers.to'
                          )
                        }}
                      </span>
                      <v-text-field
                        :value="localPlan.limit_registers"
                        disabled
                        class="rounded-lg"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <!------------------------------------------>
                <!-- LIMITS INCOMES ----------------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <span
                    class="subtitle-2 grey--text text--darken-2 font-weight-regular"
                  >
                    {{
                      $t('pricing_model.view.plan.limits_table.incomes.title')
                    }}
                  </span>
                  <v-row>
                    <v-col cols="12" md="6" class="mt-4 d-flex">
                      <span
                        class="subtitle-2 mr-4 mt-3 grey--text text--darken-2 font-weight-regular"
                      >
                        {{
                          $t(
                            'pricing_model.view.plan.limits_table.incomes.from'
                          )
                        }}
                      </span>
                      <v-text-field
                        :value="localPlan.offset_incomes"
                        disabled
                        class="rounded-lg"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      class="mt-4 d-flex"
                      v-if="!localPlan.has_no_limits"
                    >
                      <span
                        class="subtitle-2 mr-4 mt-3 grey--text text--darken-2 font-weight-regular"
                      >
                        {{
                          $t('pricing_model.view.plan.limits_table.incomes.to')
                        }}
                      </span>
                      <v-text-field
                        :value="localPlan.limit_incomes"
                        disabled
                        class="rounded-lg"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <!------------------------------------------>
              <!-- AMOUNT ----------------------------->
              <!------------------------------------------>
              <v-col cols="12" md="6" v-if="!plan.custom_amount">
                <!-- <span
                  class="subtitle-2 grey--text text--darken-2 font-weight-regular"
                  >{{ $t("pricing_model.edit.plan.amount") }}</span
                > -->
                <v-text-field
                  v-model="localPlan.amount"
                  :label="
                    `${$t('pricing_model.edit.plan.amount')} ${
                      localPlan.currency.code
                    } (${localPlan.currency.symbol})`
                  "
                  class="rounded-lg mt-1"
                  outlined
                  dense
                  :rules="rules.amount"
                  required
                >
                </v-text-field>
              </v-col>
              <!------------------------------------------>
              <!-- FEE_PERCENTAGE ----------------------------->
              <!------------------------------------------>
              <v-col cols="12" md="6" v-if="!plan.custom_fee">
                <!-- <span
                  class="subtitle-2 grey--text text--darken-2 font-weight-regular"
                  >{{ $t("pricing_model.edit.plan.fee_percentage") }}</span
                > -->
                <v-text-field
                  v-model="localPlan.fee_percentage"
                  :label="`${$t('pricing_model.edit.plan.fee_percentage')} %`"
                  class="rounded-lg mt-1"
                  outlined
                  dense
                  :rules="rules.fee_percentage"
                  required
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <!------------------------------------------>
          <!-- AUTOMATION ----------------------------->
          <!------------------------------------------>
          <v-col
            cols="12"
            v-if="!plan.custom_automation && plan.plan_automation"
          >
            <v-card class="rounded-lg" flat style="border: 1px solid #BCBCBC;">
              <v-card-title
                class="subtitle-1 grey--text text--darken-2 font-weight-regular"
              >
                {{ $t('pricing_model.edit.plan.automation') }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="localPlan.plan_automation.description"
                      :label="$t('pricing_model.edit.plan.description')"
                      class="rounded-lg mt-1"
                      outlined
                      dense
                      :rules="rules.description"
                      required
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="localPlan.plan_automation.email_cost"
                      :label="
                        `${$t('pricing_model.edit.plan.email_cost')} ${
                          localPlan.currency.code
                        } (${localPlan.currency.symbol})`
                      "
                      class="rounded-lg mt-1"
                      outlined
                      dense
                      :rules="rules.amount"
                      required
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="d-flex justify-end mt-6" style="gap: 12px;">
            <v-btn class="rounded-lg" color="#999" @click="reset">
              <span style="color: white;">{{ $t('actions.clean') }}</span>
            </v-btn>
            <v-btn
              class="rounded-lg"
              color="#2661FF"
              @click="save"
              :loading="isUpdateLoading"
              :disabled="noChanges"
            >
              <span style="color: white;">{{ $t('actions.save') }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'EditPlan',
  props: {
    plan: { type: Object, required: true, default: () => {} }
  },
  data () {
    return {
      valid: true,
      isUpdateLoading: false,
      rules: {
        name: [v => !!v || this.$t('pricing_model.edit.plan.rules.name')],
        description: [
          v =>
            (!!v && v.length > 10) ||
            this.$t('pricing_model.edit.plan.rules.description')
        ],
        frequency: [
          v => !!v || this.$t('pricing_model.edit.plan.rules.frequency')
        ],
        amount: [
          v =>
            /^\d+(\.\d+)?$/.test(v) ||
            v === null ||
            this.$t('pricing_model.edit.plan.rules.amount.number'),
          v =>
            (v && v.toString().split('.').length < 2) ||
            (v && v.toString().split('.')[1].length <= 2) ||
            this.$t('pricing_model.edit.plan.rules.amount.decimal'),
          v =>
            (v && v >= 0) || this.$t('pricing_model.edit.plan.rules.amount.min')
        ],
        fee_percentage: [
          v =>
            !!v ||
            this.$t('pricing_model.edit.plan.rules.fee_percentage.required'),
          v =>
            /^\d+(\.\d+)?$/.test(v) ||
            this.$t('pricing_model.edit.plan.rules.fee_percentage.number'),
          v =>
            (v && v.toString().split('.').length < 2) ||
            (v && v.toString().split('.')[1].length <= 2) ||
            this.$t('pricing_model.edit.plan.rules.fee_percentage.decimal'),
          v =>
            (v && v >= 0) ||
            this.$t('pricing_model.edit.plan.rules.fee_percentage.min'),
          v =>
            (v && v <= 100) ||
            this.$t('pricing_model.edit.plan.rules.fee_percentage.max')
        ]
      },
      frequencies: [
        {
          text: this.$t('pricing_model.edit.plan.frequencies.monthly'),
          value: 1
        },
        {
          text: this.$t('pricing_model.edit.plan.frequencies.yearly'),
          value: 2
        }
      ],
      localPlan: null
    }
  },
  created () {
    this.init()
  },
  computed: {
    noChanges () {
      const planKeys = Object.keys(this.plan)
      return planKeys.every(key => {
        const planValue = this.plan[key]
        const localValue = this.localPlan[key]
        return this.isEqual(planValue, localValue)
      })
    }
  },
  methods: {
    ...mapActions({
      updatePlan: 'plans/updatePlan'
    }),
    init () {
      this.plan.id = parseInt(this.plan.id)
      this.plan.frequency = parseInt(this.plan.frequency)
      this.localPlan = {
        ...this.plan,
        frequency: parseInt(this.plan.frequency),
        id: parseInt(this.plan.id)
      }
    },
    isEqual (a, b) {
      if (a === b) return true
      if (typeof a !== 'object' || typeof b !== 'object') return false
      const keysA = Object.keys(a)
      const keysB = Object.keys(b)
      if (keysA.length !== keysB.length) return false
      for (const key of keysA) {
        if (!keysB.includes(key) || !this.isEqual(a[key], b[key])) return false
      }
      return true
    },
    validate () {
      return this.$refs.form.validate()
    },
    reset () {
      this.localPlan = {
        ...this.plan,
        frequency: parseInt(this.plan.frequency),
        id: parseInt(this.plan.id)
      }
    },
    async save () {
      if (this.validate()) {
        try {
          this.isUpdateLoading = true

          // Update in database
          const updatedPlan = await this.updatePlan(this.localPlan)

          // Update in list
          this.$emit('update-plan', updatedPlan)
        } catch (error) {
        } finally {
          this.isUpdateLoading = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-expansion-panel::before {
  box-shadow: none;
}
</style>
